"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.ragStatus.pending': 'In attesa',
    'knowledge.ragStatus.processing': 'In elaborazione',
    'knowledge.ragStatus.completed': 'Completato',
    'knowledge.ragStatus.failed': 'Fallito',
    'knowledge.ragStatus.not_indexed': 'Non applicabile',
    'knowledge.ragStatus.ready': 'Pronto',
    'knowledge.ragStatus.disabled': 'Disabilitato',
};
